// @flow
import type {Status} from 'bfu-auth-client/src/login/types/Types.js';

type ParcelControl = {
    onChangeStatus: {
        error: {
            message: string,
            name: string
        },
        isRejected: boolean
    }
};

const ParcelControlComponent =  (parcelControl: ParcelControl, status: ?Status): ?Status => {
    let {error, isRejected} = parcelControl.onChangeStatus;

    if(!isRejected) {
        return status;
    }

    if(error.message === 'User cannot be confirm. Current status is CONFIRMED') {
        return {
            message: `You are already confirmed, please go back to the sign-in page and sign in`,
            modifier: 'positive'
        };
    }

    if(error.name === 'UserNotFoundException') {
        return {
            message: `No users were found with this username. Please sign up first using the link below.`,
            modifier: 'negative'
        };
    }

    if(error.name === 'UsernameExistsException') {
        return {
            message: `This user has already signed up. Please go back to the sign in page and try to sign in`,
            modifier: 'negative'
        };
    }

    if(error.name === 'USER_NOT_INVITED') {
        return {
            message: `This user hasn't been invited yet. Please make sure that you have typed your username correctly. If you still cannot sign up, please speak to your system administrator.`,
            modifier: 'negative'
        };
    }

    if(error.name === 'USER_EMAIL_MISMATCH') {
        return {
            message: `The email address you provided does not match the email address we have on file. Please double check that the email address you entered is the same as the one you have been invited with. If you still cannot sign up, please speak to your system administrator.`,
            modifier: 'negative'
        };
    }

    if(error.name === 'USER_DOES_NOT_EXIST') {
        return {
            message: `We have no record of this user in our system. Please contact your system administrator.`,
            modifier: 'negative'
        };
    }

    if(error.name === 'USER_EMAIL_NOT_UNIQUE') {
        return {
            message: 'There are multiple active users with this email address, please sign in with your username instead',
            modifier: 'negative'
        };
    }

    return {
        message: error.message,
        modifier: 'negative'
    };
};

export default ParcelControlComponent;